if (!customElements.get('ft-cart-suggestions')) {
  customElements.define('ft-cart-suggestions', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', (event) => {
        event.stopPropagation();
        if (event.target.matches('select[name="id"]')) {
          const price = event.target.selectedOptions[0]?.dataset.price;
          if (price) event.target.closest('article').querySelector('[data-suggestion-price]').textContent = price;
        }
      });
      this.addEventListener('submit', (event) => this.add(event));
    }

    async add(event) {
      const form = event.target;
      if (!form.matches('.ft-cart-suggestion__form')) return;
      event.preventDefault();
      event.stopPropagation();
      if (this.busy || !form.reportValidity()) return;
      const drawer = this.closest('cart-drawer');
      const button = form.querySelector('[type="submit"]');
      const error = form.querySelector('[role="alert"]');
      this.busy = true;
      error.hidden = true;
      this.setAttribute('aria-busy', 'true');
      this.querySelectorAll('button,select').forEach((control) => { control.disabled = true; });
      const data = new FormData(form);
      const select = form.querySelector('select[name="id"]');
      data.set('id', select.value);
      data.set('sections', drawer.getSectionsToRender().map((section) => section.id).join(','));
      data.set('sections_url', window.location.pathname);
      drawer.setActiveElement(document.getElementById('cart-icon-bubble'));
      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: data,
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        if (!result.sections || !result.sections['cart-drawer']) {
          window.location.assign(window.routes.cart_url);
          return;
        }
        drawer.renderContents(result);
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'ft-cart-suggestions', productVariantId: data.get('id'), cartData: result,
        });
      } catch (failure) {
        error.textContent = failure.message || this.dataset.error;
        error.hidden = false;
        button.focus();
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        this.querySelectorAll('button,select').forEach((control) => { control.disabled = false; });
      }
    }
  });
}
